import { hostFactory as hostInstance } from "../factory";

const getRpeById = id => hostInstance.get(`/api/rpes/${id}`);

const getRpes = () => hostInstance.get("/api/rpes");

const deleteRpe = id => hostInstance.delete(`/api/rpes/${id}`);

export { getRpeById, deleteRpe };

export default getRpes;
